import { ListChart, ListChartProps } from '../../../renderers/list-chart/list-chart.component';
import { IOTS_VOLUME_BY_TYPE_LIST_CHART_DEFINITION } from './iots-volume-by-type-list-chart.definition';
import { IOTS_VOLUME_BY_TYPE_LIST_CHART_MOCK_DATA } from './iots-volume-by-type-list-chart.mock';

export const IotsVolumeByTypeListChart = (props: ListChartProps) => <ListChart {...props} />;

IotsVolumeByTypeListChart.definition = IOTS_VOLUME_BY_TYPE_LIST_CHART_DEFINITION;
IotsVolumeByTypeListChart.mockData = IOTS_VOLUME_BY_TYPE_LIST_CHART_MOCK_DATA;
